import { appMethod as app } from '@utils/app';
import util from '@utils/util';
import { getCurrentPageQueryParams, convertLineStyleData } from '@utils/tools';
import { TopNav } from '@common/top-nav/TopNav';
import OfficialPage from '../OfficialPage';

import './RefundDishesDetail.less';

export default class RefundDishesDetail extends OfficialPage {
  state = {}

  constructor(props) {
    super(props);
    document.title = '退款详情';
  }

  componentWillMount(options = getCurrentPageQueryParams()) {
    let account_type = options.type
    let orderId = options.detail
    this.setData({
      account_type: account_type,
      orderId: orderId
    })
    account_type == 1 ? this.getRufundDetail() : this.getModifyOrderList()
  }

  getModifyOrderList = () => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=AppEcommerce/getModifiedOrderList',
      data: {
        order_id: this.data.orderId
      },
      success: function (res) {
        for (let i = 0; i < res.data.length; i++) {
          let goods = res.data[i].form_data.apply_goods
          for (let j = 0; j < goods.length; j++) {
            if (!goods[j].model_value) break
            goods[j].model_value_str = goods[j].model_value.join('|')
          }
        }
        that.setData({
          diningOrderList: res.data
        })
      }
    })
  }
  getRufundDetail = () => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=/AppEcommerce/getOrderRefundApplyByOrderId',
      data: {
        order_id: this.data.orderId
      },
      success: function (res) {
        that.setData({
          orderInfo: res.data
        })
        that.modifyTime(res.data[0].add_time)
      }
    })
  }
  modifyTime = time => {
    let add_time = util.formatTimeYMD(time)
    this.setData({
      add_time: add_time
    })
  }

  render() {
    const {
      showGetUserInfo,
      add_time,
      account_type,
      orderInfo,
      diningOrderList
    } = this.state

    return (
      <div className="official-page refund-dishes-detail">
        <TopNav title="退款详情"/>
        {account_type == 1 ? (
          <div className="refund-wrapper">
            {orderInfo && orderInfo.map((item, index) => {
              return (
                <React.Fragment key={index}>
                  <div className="refund-head flex-between">
                    <div>{'第' + (index + 1) + '次退款'}</div>
                    <div>{'申请时间：' + add_time}</div>
                  </div>
                  <div
                    className="refund-goods-wrapper"
                    style={convertLineStyleData('margin-bottom:10rpx;')}
                  >
                    <div className="refund-title" hidden={index > 0}>
                      退款商品
                    </div>
                    {item.form_data.refund_goods.map((goods, index) => {
                      return (
                        <React.Fragment key={index}>
                          <div className="goods-info-item">
                            <div className="goods-image">
                              <img
                                src={goods.cover}
                                mode="aspectFill"
                              />
                            </div>
                            <div className="goods-detail">
                              <div className="flex-between">
                                <div style={convertLineStyleData('display:flex;align-items:center;')}>
                                  {goods.max_can_use_integral > 0 && (
                                    <span className="goods-special">积</span>
                                  )}
                                  {goods.is_seckill == 1 && (
                                    <span className="goods-special">秒杀</span>
                                  )}
                                  <span
                                    className="goods-name ellipsis"
                                    style={convertLineStyleData('max-width:400rpx;')}
                                  >
                                    {goods.title}
                                  </span>
                                </div>
                              </div>
                              <div className="goods-type">
                                {goods.model_name && (
                                  <div className="type-size">
                                    {goods.model_name}
                                  </div>
                                )}
                              </div>
                              <div className="goods-price flex-between">
                                <div className="price-box">
                                  <span className="priceNow">
                                    <span style={convertLineStyleData('font-size:30rpx;')}>￥</span>
                                    {goods.is_vip_goods
                                      ? goods.price
                                      : goods.original_price || goods.price}
                                  </span>
                                  {goods.is_vip_goods && (
                                    <span className="dinning_vip_tips">
                                      会员价
                                    </span>
                                  )}
                                  {goods.is_vip_goods && (
                                    <span style={convertLineStyleData('color:#999;font-size:26rpx;')}>
                                      {'¥' + goods.original_price}
                                    </span>
                                  )}
                                </div>
                                <div
                                  className="calculate-wrapper"
                                  style={convertLineStyleData('color:#999;')}
                                >
                                  {'x' + goods.num}
                                </div>
                              </div>
                            </div>
                          </div>
                        </React.Fragment>
                      )
                    })}
                    <div className="refunds-price-wrapper">
                      <div className="refund-info-item flex-between">
                        <span id="refund-price" style={convertLineStyleData('color:#999;')}>
                          退款金额
                        </span>
                        <span>{'￥' + item.refund_price}</span>
                      </div>
                      <div className="refund-info-item flex-between">
                        <span style={convertLineStyleData('color:#999;')}>退款方式</span>
                        <span>原付款方式退回</span>
                      </div>
                      <div className="refund-info-item flex-between">
                        <span style={convertLineStyleData('color:#999;')}>退款说明</span>
                        <span>{item.form_data.refund_reason_info}</span>
                      </div>
                    </div>
                  </div>
                </React.Fragment>
              )
            })}
          </div>
        ) : (
            account_type == 2 && (
              <div className="refund-wrapper" style={convertLineStyleData('padding-top:30rpx;')}>
                {diningOrderList.map((item, index) => {
                  return (
                    <React.Fragment key={index}>
                      <div className="refund-head flex-between">
                        <div>
                          {'第' +
                            (index + 1) +
                            '次退菜' +
                            (item.from_admin == 1 ? '（商家）' : '')}
                        </div>
                        <div>{'申请时间：' + item.apply_time}</div>
                      </div>
                      <div
                        className="refund-goods-wrapper"
                        style={convertLineStyleData('margin-bottom:10rpx;')}
                      >
                        <div className="refund-title">退菜商品</div>
                        {item.form_data.apply_goods.map((goods, index) => {
                          return (
                            <React.Fragment key={index}>
                              <div className="goods-info-item">
                                <div className="goods-image">
                                  <img
                                    src={goods.cover}
                                    mode="aspectFill"
                                  />
                                </div>
                                <div className="goods-detail">
                                  <div className="flex-between">
                                    <div style={convertLineStyleData('display:flex;align-items:center;')}>
                                      {goods.max_can_use_integral > 0 && (
                                        <span className="goods-special">积</span>
                                      )}
                                      {goods.is_seckill == 1 && (
                                        <span className="goods-special">
                                          秒杀
                                      </span>
                                      )}
                                      <span
                                        className="goods-name ellipsis"
                                        style={convertLineStyleData('max-width:400rpx;')}
                                      >
                                        {goods.goods_name}
                                      </span>
                                    </div>
                                  </div>
                                  {goods.model_value_str && (
                                    <div className="goods-type">
                                      <div className="type-size ellipsis">
                                        {goods.model_value_str}
                                      </div>
                                    </div>
                                  )}
                                  <div className="goods-price flex-between">
                                    <div className="price-box">
                                      <span className="priceNow">
                                        <span style={convertLineStyleData('font-size:30rpx;')}>￥</span>
                                        {goods.is_vip_goods
                                          ? goods.price
                                          : goods.original_price || goods.price}
                                      </span>
                                      {goods.is_vip_goods && (
                                        <span className="dinning_vip_tips">
                                          会员价
                                      </span>
                                      )}
                                      {goods.is_vip_goods && (
                                        <span style={convertLineStyleData('color:#999;font-size:26rpx;')}>
                                          {'¥' + goods.original_price}
                                        </span>
                                      )}
                                    </div>
                                    <div
                                      className="calculate-wrapper"
                                      style={convertLineStyleData('color:#999;')}
                                    >
                                      {'x' + goods.num}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </React.Fragment>
                          )
                        })}
                      </div>
                    </React.Fragment>
                  )
                })}
              </div>
            )
          )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/refund-dishes-detail/RefundDishesDetail.jsx